<div class="dialog-header">
    <h6>{{ isEditMode ? 'Edit Port' : 'Add Port' }}</h6>
    <button mat-icon-button class="close-icon" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<form [formGroup]="portForm">
    <div class="vessel-card-container">
        <div style="display: flex; gap:20px">
            <div style="display: flex; gap:20px">
                <!-- Country Autocomplete -->
                <mat-form-field appearance="outline">
                    <input type="text" matInput placeholder="Select Country" formControlName="country_id"
                        [matAutocomplete]="autoCountry" (input)="onCountryInput($event)" [readonly]="isEditMode">
                    <mat-autocomplete #autoCountry="matAutocomplete"
                        (optionSelected)="onCountrySelected($event.option.value)" [displayWith]="displayCountryFn">
                        <mat-option *ngFor="let country of filteredCountries$ | async" [value]="country.name">
                            {{ country.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error
                        *ngIf="portForm.get('country_id')?.hasError('required') && portForm.get('country_id')?.touched">
                        Please select the country name
                    </mat-error>
                </mat-form-field>

                <!-- Port Autocomplete -->
                <mat-form-field appearance="outline">
                    <input type="text" matInput placeholder="Select Port" formControlName="port_id"
                        [matAutocomplete]="autoPort" (input)="onPortInput($event)"
                        [readonly]="isEditMode && !portChecked">
                    <mat-autocomplete #autoPort="matAutocomplete" (optionSelected)="onPortSelected($event.option.value)"
                        [displayWith]="displayPortFn">
                        <mat-option *ngFor="let port of filteredPorts$ | async" [value]="port.name">
                            {{ port.name }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error
                        *ngIf="portForm.get('port_id')?.hasError('required') && portForm.get('port_id')?.touched">
                        Please select the port name
                    </mat-error>
                </mat-form-field>


                <button mat-button type="button" class="add-vessel-field" (click)="openMultipleVesselCreationDialog()">
                    <span>Add Vessel Field</span></button>
            </div>
            <div *ngIf="isEditMode == true">

                <mat-checkbox (change)="toCopyRule($event)">Select to copy rule</mat-checkbox>
            </div>

        </div>
        <div formArrayName="vessel_fields" class="scroll-vessel-fields">
            <div *ngFor="let field of vesselFields.controls; let i = index" [formGroupName]="i">
                <div class="vessel-card-compact">
                    <div class="card-content">
                        <span class="field-name">{{ field.get('field_name')?.value }}</span>
                        <span class="field-separator">|</span>
                        <span class="field-type">{{splitDataType(field.get('data_type')?.value).type }}</span>
                        <span class="field-separator">|</span>
                        <span class="field-required" [class.required-yes]="field.get('is_mandatory')?.value == 'Y'"
                            [class.required-no]="field.get('is_mandatory')?.value == 'N'">
                            {{ (field.get('is_mandatory')?.value) == 'Y' ? 'Required' : 'Optional' }}
                        </span>
                    </div>
                    <div class="card-actions">
                        <button mat-icon-button class="edit-btn" type="button"
                            (click)="openEditSingleVesselField(field.value, i)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button class="delete-btn" (click)="removeVesselField(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- table section  -->

    <div class="topbar">
        <div class="search-section">
            <mat-form-field class="search-bar" appearance="outline">
                <mat-label>Tariff</mat-label>
                <input matInput />
                <mat-icon matSuffix *ngIf="searchTerm" (click)="clearSearch()" class="close-icon">close</mat-icon>
            </mat-form-field>
            <button class="search-icon" mat-icon-button type="button" (click)="onSearch()">
                <mat-icon class="search">search</mat-icon>
            </button>
        </div>
        <div style="display: flex; gap: 10px;">
            <button mat-raised-button color="primary" name="add-tariff" class="add-button" type="button"
                (click)="openAddOrEditTariffDialog()">
                Add Tariff
            </button>
        </div>
    </div>

    <div *ngIf="tableDataSource?.data as data">
        <ng-container *ngIf="data.length > 0; else noData">
            <div class="table-container" (scroll)="onManualScroll()">
                <table mat-table [dataSource]="tableDataSource" class="mat-elevation-z8 full-width-table tariff-rules-table" 
                    cdkDropList
                    (cdkDropListDropped)="drop($event)">

                    <!-- Sl.No Column -->
                    <ng-container matColumnDef="sno">
                        <th mat-header-cell *matHeaderCellDef style="width: 40px;">SNO</th>
                        <td mat-cell *matCellDef="let element; let i = index" [attr.rowspan]="getSNORowSpan(element, i)"
                            [style.display]="shouldShowSNOCell(element, i) ? 'table-cell' : 'none'"
                            style="vertical-align: middle; text-align: center; border-right: 1px solid #e0e0e0;">
                            {{ element.sno }}
                        </td>
                    </ng-container>

                    <!-- Service Column -->
                    <ng-container matColumnDef="service">
                        <th mat-header-cell *matHeaderCellDef style="min-width: 100px;">Service</th>
                        <td mat-cell *matCellDef="let element; let i = index"
                            [attr.rowspan]="getServiceRowSpan(element, i)"
                            [style.display]="shouldShowServiceCell(element, i) ? 'table-cell' : 'none'"
                            style="vertical-align: middle; border-right: 1px solid #e0e0e0;">
                            {{ element.service }}
                            <p *ngIf="element.purpose" style="font-size: 10px; color: #666; margin-top: 6px;">({{
                                element.purpose }})</p>
                        </td>
                    </ng-container>

                    <!-- Info Column -->
                    <ng-container matColumnDef="info_msg">
                        <th mat-header-cell *matHeaderCellDef>Remarks</th>
                        <td mat-cell *matCellDef="let element; let i = index"
                            [attr.rowspan]="getInfoRowSpan(element, i)"
                            [style.display]="shouldShowInfoCell(element, i) ? 'table-cell' : 'none'"
                            style="vertical-align: middle; border-left: 1px solid #e0e0e0; min-width: 160px;">
                            {{ element.info_msg || '—' }}
                        </td>
                    </ng-container>

                    <!-- Subservice Column -->
                    <ng-container matColumnDef="subservice">
                        <th mat-header-cell *matHeaderCellDef style="min-width: 200px;">Subservice</th>
                        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                    </ng-container>

                    <!-- Base Value Column -->
                    <ng-container matColumnDef="basic_value">
                        <th mat-header-cell *matHeaderCellDef style="min-width: 150px;">Base value</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.basic_value ? element.basic_value.split(":")[1] : '' }}
                        </td>
                    </ng-container>

                    <!-- Movement Column -->
                    <ng-container matColumnDef="movement">
                        <th mat-header-cell *matHeaderCellDef style="width: 70px;">Movement</th>
                        <td mat-cell *matCellDef="let element"> {{ element.movement ? element.movement.split(":")[1] :
                            '' }}</td>
                    </ng-container>

                    <!-- Tariff % Column -->
                    <ng-container matColumnDef="tariff_percent">
                        <th mat-header-cell *matHeaderCellDef style="width: 100px;">Tariff %</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.tariff_percent ? element.tariff_percent.split(":")[1] : '' }}
                        </td>
                    </ng-container>


                    <!-- Result Formula Column -->
                    <ng-container matColumnDef="formula_result">
                        <th mat-header-cell *matHeaderCellDef style="min-width: 250px;">Result Formula</th>
                        <td mat-cell *matCellDef="let element">{{ element.formula_result }}</td>
                    </ng-container>

                    <!-- Optional Column -->
                    <ng-container matColumnDef="optional">
                        <th mat-header-cell *matHeaderCellDef style="width: 50px;">Optional</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="element.optional" disabled></mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef style="width: 100px;">Action</th>
                        <td mat-cell *matCellDef="let element; let i = index"
                            [attr.rowspan]="getActionRowSpan(element, i)"
                            [style.display]="shouldShowActionCell(element, i) ? 'table-cell' : 'none'"
                            style="vertical-align: middle; text-align: center;">
                            <button class="edit-icon-button" mat-icon-button type="button"
                                (click)="openAddOrEditTariffDialog(element, i)">
                                <mat-icon style="font-size: 17px;">edit</mat-icon>
                            </button>
                            <button mat-icon-button class="delete-btn" type="button"
                                (click)="deleteService(element, i)">
                                <mat-icon class="delete-icon" fontSet="material-symbols-outlined">delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <!-- Header & Row Definitions -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index" cdkDrag
                        [ngClass]="row.groupClass" [cdkDragDisabled]="!shouldShowDragHandleCell(row, i)"
                        cdkDragLockAxis="y"
                        [attr.data-service-group]="'service-' + row.service + '-' + (row.purpose || 'no-purpose')"></tr>
                </table>

            </div>
        </ng-container>
    </div>

    <ng-template #noData>
        <div class="no-data-text">
            No data found.
        </div>
    </ng-template>

    <button class="add-port-tariff" (click)="onSubmitPortTariff()">{{ isEditMode ? 'Update Port & Tariff' : 'Save Port &
        Tariff'}}</button>
</form>